<!-- <div class="{{buttonAlignmentClass}} rowIcons" [hidden]="actionButtons.length == 0">
    <a style="padding: 0px 5px;" *ngFor="let item of actionButtons" [ngClass]="{'disabled': item.isDisabled }"
        [hidden]="item.isHidden" (click)="onUserAction(item.userAction);">
        <em [ngClass]="item.buttonClass" tooltipClass="my-custom-class-recall" ngbTooltip="{{ item.buttonTooltip | translate: param }}" placement="left"
            container="body"></em>
    </a>
</div> -->
<div class="{{buttonAlignmentClass}} rowIcons" [hidden]="actionButtons.length == 0">
    <a style="padding: 0px 5px;" *ngFor="let item of actionButtons" [ngClass]="{'disabled': item.isDisabled,'btn-edit-ag-grid-guide':isFirstRow  }"
        [hidden]="item.isHidden" (click)="onUserAction(item.userAction);">
        <em *ngIf="!item.buttonClass?.includes('fa-file-search')" [ngClass]="item.buttonClass"
            tooltipClass="my-custom-class-recall" ngbTooltip="{{ item.buttonTooltip | translate: param }}"
            placement="left" container="body"></em>
 
        <img *ngIf="item.buttonClass?.includes('fa-file-search')" src="../../../assets/svg-icons/file-search.svg" alt=""
            width="18px" class="">
    </a>
 
</div>